export const DELETE_TABLE='DELETE_TABLE'
export const DELETE_TABLE_SUCCESS= 'DELETE_TABLE_SUCCESS'
export const DELETE_TABLE_ERROR= 'DELETE_TABLE_ERROR'

export const DeleteTable= (data) => ({
    type: DELETE_TABLE,
    payload: data
});
